import * as Types from '../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CancelRollupInvoiceMutationVariables = Types.Exact<{
  invoiceNumber: Types.Scalars['String'];
  notes: Types.Scalars['String'];
}>;


export type CancelRollupInvoiceMutation = { __typename?: 'MutationModel', customRollupInvoices?: { __typename?: 'CustomRollupInvoiceMutationModel', cancel?: { __typename?: 'ValidationResponse', errors?: Array<{ __typename?: 'ValidationError', argumentName?: string | null, message: string } | null> | null } | null } | null };


export const CancelRollupInvoiceDocument = gql`
    mutation CancelRollupInvoice($invoiceNumber: String!, $notes: String!) {
  customRollupInvoices {
    cancel(invoiceNumber: $invoiceNumber, notes: $notes) {
      errors {
        argumentName
        message
      }
    }
  }
}
    `;
export type CancelRollupInvoiceMutationFn = Apollo.MutationFunction<CancelRollupInvoiceMutation, CancelRollupInvoiceMutationVariables>;

/**
 * __useCancelRollupInvoiceMutation__
 *
 * To run a mutation, you first call `useCancelRollupInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelRollupInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelRollupInvoiceMutation, { data, loading, error }] = useCancelRollupInvoiceMutation({
 *   variables: {
 *      invoiceNumber: // value for 'invoiceNumber'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useCancelRollupInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<CancelRollupInvoiceMutation, CancelRollupInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelRollupInvoiceMutation, CancelRollupInvoiceMutationVariables>(CancelRollupInvoiceDocument, options);
      }
export type CancelRollupInvoiceMutationHookResult = ReturnType<typeof useCancelRollupInvoiceMutation>;
export type CancelRollupInvoiceMutationResult = Apollo.MutationResult<CancelRollupInvoiceMutation>;
export type CancelRollupInvoiceMutationOptions = Apollo.BaseMutationOptions<CancelRollupInvoiceMutation, CancelRollupInvoiceMutationVariables>;